import {
    defaultRuleTipPrudence,
    defaultFilterRulesTipsPrudence,
} from "./state";

/**
 * Mutación que establece las reglas de consejos de prudencia de SGA.
 *
 * @param {*} state.rulesTipsPrudence - Estado de las reglas de consejos de prudencia de SGA.
 * @param rulesTipsPrudence - Reglas de consejos de prudencia de SGA.
 * @return {void}
 * @author Brandon Torres
 */
export function setRulesTipsPrudenceSga(state, rulesTipsPrudence) {
    state.rulesTipsPrudence = rulesTipsPrudence;
}

/**
 * Mutación que establece la acción a realizar.
 *
 * @param {*} state.action - Estado de la acción.
 * @param action - Acción a realizar.
 * @return {void}
 * @author Brandon Torres
 */
export function setActionRuleTipPrudence(state, action) {
    state.action = action;
}

/**
 * Mutación que establece la regla de consejo de prudencia por defecto.
 *
 * @param {*} state.ruleTipPrudence - Estado de la regla de consejo de prudencia.
 * @return {void}
 * @author Brandon Torres
 */
export function setDefaultRuleTipPrudenceSga(state) {
    state.ruleTipPrudence = defaultRuleTipPrudence();
}

/**
 * Mutación que establece el filtro de las reglas de consejos de prudencia de SGA por defecto.
 *
 * @param {*} state.filterRulesTipsPrudence - Estado del filtro de las reglas de consejos de prudencia de SGA.
 * @return {void}
 * @author Brandon Torres
 */
export function setDefaultFilterRulesTipsPrudence(state) {
    state.filterRulesTipsPrudence = defaultFilterRulesTipsPrudence();
}

/**
 * Mutación que establece la cantidad de reglas de consejos de prudencia por página.
 *
 * @param {*} state.filterRulesTipsPrudence.per_page - Cantidad de registros por página.
 * @param {*} state.filterRulesTipsPrudence.page - Página actual.
 * @param per_page - Cambio de cantidad de registros por página.
 * @return {void}
 * @author Brandon Torres
 */
export function loadAfterChangeSizePagination(state, per_page) {
    state.filterRulesTipsPrudence = {
        ...state.filterRulesTipsPrudence,
        page: 1,
        per_page: per_page,
    };
}

/**
 * Mutación que establece la página actual.
 *
 * @param {*} state.filterRulesTipsPrudence.page - Página actual.
 * @param page - Cambio de página actual.
 * @return {void}
 * @author Brandon Torres
 */
export function loadAfterChangePagePagination(state, page) {
    state.filterRulesTipsPrudence.page = page;
}

/**
 * Mutación que establece el paginador de registros de las reglas de consejos de prudencia.
 *
 * @param {*} state.filterRulesTipsPrudence.page - Página actual.
 * @param {*} state.filterRulesTipsPrudence.per_page - Cantidad de registros por página.
 * @param {*} state.filterRulesTipsPrudence.total - Total de registros.
 * @param paginate - Paginación de registros.
 * @return {void}
 * @author Brandon Torres
 */
export function setPaginateRulesTipsPrudenceSga(state, paginate) {
    state.filterRulesTipsPrudence = {
        ...state.filterRulesTipsPrudence,
        page: paginate.current_page,
        per_page: paginate.per_page,
        total: paginate.total,
    };
}

/**
 * Mutación que establece la regla de consejo de prudencia de SGA.
 *
 * @param {*} state.ruleTipPrudence - Estado de la regla de consejo de prudencia.
 * @param ruleTipPrudence - Regla de consejo de prudencia de SGA.
 * @return {void}
 * @author Brandon Torres
 */
export function setRuleTipPrudenceSga(state, ruleTipPrudence) {
    state.ruleTipPrudence = {
        id: ruleTipPrudence.id,
        name: ruleTipPrudence.name,
        sga_prudence_tip_code_combination_ids:
            ruleTipPrudence.sga_prudence_tip_code_combination_ids,
        sga_prudence_tip_code_display_ids:
            ruleTipPrudence.sga_prudence_tip_code_display_ids,
    };
}
